import { Feature } from "ol";
import { Circle, Geometry, Point } from "ol/geom";
import Style from "ol/style/Style";
import BaseFeature from "./base.feature";
import { Fill, Icon, Stroke, Text } from "ol/style";
import IGeofence from "@/models/dto/IGeofence";
import GeofenceUtil from "@/utils/geofence.util";

export default class CircleGeofenceFeature extends BaseFeature {

    geofence: IGeofence

    constructor(geofence: IGeofence) {
        super();
        this.geofence = geofence
    }

    getFeature(): Feature<Circle> {
        const circleGeom = GeofenceUtil.parseCircleGeometry(this.geofence.area)
        const circleFeature = new Feature({
            type: 'geofence',
            geometry: circleGeom
        });
        return circleFeature
    }

    getCenterFeature(): Feature<Geometry> {
        const center = this.getFeature().getGeometry()!.getCenter()
        const iconFeature = new Feature({
            type: 'geofence',
            geometry: new Point(center)
        });
        iconFeature.setStyle(this.getStyle())
        return iconFeature
    }

    getStyle(): Style {
        return new Style({
            stroke: new Stroke({
                color: '#6610f2',
                width: 3
            }),
            fill: new Fill({
                color: 'rgba(128, 0, 128, 0.1)'
            }),
            image: new Icon(({
                anchor: [0.5, 0.5],
                scale: 0.7,
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                crossOrigin: 'anonymous',
                src: require("@/assets/img/geofences/" + (this.geofence.attributes.icon || '0') + ".png")
            })),
            text: new Text({
                font: 'bold 20px Changa',
                overflow: true,
                text: this.geofence.name || 'sadsdad',
                fill: new Fill({
                    color: '#6610f2'
                }),
                stroke: new Stroke({
                    color: '#fff',
                    width: 2
                }),
                offsetY: 28,
                scale: 1
            })
        });
    }

    isValid(): boolean {
        return true
    }

}